import { GET_ILEGGELSELEVERINGSTYPER_SUCCESS } from "../actions/ileggelseleveringstyperActions";

const INITIAL_STATE = [];

export default function ileggelseleveringstyperReducer(
  state = INITIAL_STATE,
  action,
) {
  switch (action.type) {
    case GET_ILEGGELSELEVERINGSTYPER_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}
